export * from './has-permissions.directive';
